<template>
    <Head :title="__('Edit') + ' ' + role.name"/>

    <BreezeDashboardLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ __('Edit') }} {{ role.name }}
            </h2>
        </template>

        <notification v-if="success" color="success">
            {{ success }}
        </notification>

        <card-component @submit.prevent="submit" form>

            <field class="max-w-sm" :label="__('Name')" :error="errors.name ?? ''">
                <control :icon="mdiAccount" :placeholder="__('Name')" v-model="form.name"
                         :required="true"/>
            </field>

            <field class="max-w-sm" :label="__('Guard Name')" :error="errors.email ?? ''">
                <control :icon="mdiAccountChildCircle" :options="guard_name_options" v-model="form.guard_name"
                         :required="true"/>
            </field>

            <field class="max-w-sm" :label="__('Permissions')" :error="errors.permissions ?? ''">
                <check-radio-picker class="checkbox-block" type="checkbox mr-0"
                                    name="sample-checkbox"
                                    v-model="form.permissions"
                                    :options="userPermissions"
                />
            </field>

            <jb-buttons class="justify-end ml-3 md:ml-0" mb="">
                <jb-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                           type="success" color="success" :label="__('Save')"/>
                <jb-button type="button" color="danger" outline :label="__('Delete')" @click.prevent="delete" />
            </jb-buttons>
        </card-component>
    </BreezeDashboardLayout>
</template>

<style>
</style>

<script>
import BreezeDashboardLayout from '@/Layouts/Dashboard'
import CardComponent from '@/Components/Dashboard/CardComponent'
import Notification from '@/Components/Dashboard/Notification'
import {Head, usePage} from '@inertiajs/inertia-vue3';
import {
    mdiAt,
    mdiAccount,
    mdiAccountMultipleOutline,
    mdiEmail,
    mdiLink,
    mdiOpenInNew,
    mdiAccountChildCircle,
    mdiAvTimer,
    mdiTranslate,
    mdiNumeric8BoxMultipleOutline
} from '@mdi/js'
import Field from '@/Components/Dashboard/Field'
import Control from '@/Components/Dashboard/Control'
import CheckRadioPicker from '@/Components/Dashboard/CheckRadioPicker'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'

export default {
    components: {
        BreezeDashboardLayout,
        Head,
        CardComponent,
        Notification,
        Field,
        Control,
        CheckRadioPicker,
        JbButton,
        JbButtons
    },
    props: {
        success: String,
        errors: Object,
        role: Object,
        userPermissions: Object
    },
    data(props) {
        return {
            form: this.$inertia.form({
                name: props.role.name,
                guard_name: this.guard_name_options.find(key => key.id === props.role.guard_name),
                permissions: props.role.permissions.map((item) => props.userPermissions.findIndex((element) => element === item.name)),
            }),
        }
    },
    setup() {

        const guard_name_options = [
            {id: 'web', label: 'Web'},
            {id: 'api', label: 'Api'}
        ];

        return {
            mdiAccount,
            mdiAccountMultipleOutline,
            mdiAt,
            mdiLink,
            mdiOpenInNew,
            mdiEmail,
            mdiAccountChildCircle,
            mdiAvTimer,
            mdiTranslate,
            mdiNumeric8BoxMultipleOutline,
            guard_name_options
        }
    },
    methods: {
        submit() {
            this.form.put(this.route('roles.update', this.role.id), {
                onFinish: () => this.form.reset('name')
            })
        },
        delete() {
            this.$inertia.form().delete(this.route('roles.destroy', this.role.id))
        }
    }
}
</script>
